import React from "react";

const MemoChildren = React.memo(({ children, debug = false }) => {
  debug && console.log(debug)
  return (
    <>{children}</>
  )
});

export default MemoChildren;